import { createDefaultFieldFactory } from '@sitecore-jss/sitecore-jss-react-forms';

import Checkbox from './FieldTemplates/Checkbox';
import CheckboxList from './FieldTemplates/CheckboxList';
import CountrySelector from './FieldTemplates/CountrySelector';
import DropdownList from './FieldTemplates/DropdownList';
import Email from './FieldTemplates/Email';
import EmailWithConfirmation from './FieldTemplates/EmailWithConfirmation';
import FileUpload from './FieldTemplates/FileUpload';
import HiddenReferrer from './FieldTemplates/HiddenReferrer';
import HiddenText from './FieldTemplates/HiddenText';
import HintTextbox from './FieldTemplates/HintTextbox';
import MultipleLineText from './FieldTemplates/MultipleLineText';
import NumberInput from './FieldTemplates/NumberInput';
import RadioButtonList from './FieldTemplates/RadioButtonList';
import GoogleRecaptchaV3 from './FieldTemplates/Recaptcha/GoogleRecaptchaV3';
import RichText from './FieldTemplates/RichText';
import SubmitButton from './FieldTemplates/SubmitButton';
import Telephone from './FieldTemplates/Telephone';
import TelephoneWithDialCode from './FieldTemplates/TelephoneWithDialCode';
import UserDevicesSelector from './FieldTemplates/UserDevicesSelector';
import { CustomFieldTypes } from './customFieldTypes';

export function createCustomFieldFactory() {
  const defaultFieldFactory = createDefaultFieldFactory();

  defaultFieldFactory.setComponent(CustomFieldTypes.Button, SubmitButton);
  defaultFieldFactory.setComponent(CustomFieldTypes.Checkbox, Checkbox);
  defaultFieldFactory.setComponent(CustomFieldTypes.CheckboxList, CheckboxList);
  defaultFieldFactory.setComponent(CustomFieldTypes.CountrySelector, CountrySelector);
  defaultFieldFactory.setComponent(CustomFieldTypes.DropdownList, DropdownList);
  defaultFieldFactory.setComponent(CustomFieldTypes.Email, Email);
  defaultFieldFactory.setComponent(CustomFieldTypes.EmailWithConfirmation, EmailWithConfirmation);
  defaultFieldFactory.setComponent(CustomFieldTypes.FileUpload, FileUpload);
  defaultFieldFactory.setComponent(CustomFieldTypes.GoogleRecaptchaV3, GoogleRecaptchaV3);
  defaultFieldFactory.setComponent(CustomFieldTypes.HiddenReferrer, HiddenReferrer);
  defaultFieldFactory.setComponent(CustomFieldTypes.HiddenText, HiddenText);
  defaultFieldFactory.setComponent(CustomFieldTypes.HintTextbox, HintTextbox);
  defaultFieldFactory.setComponent(CustomFieldTypes.MultipleLineText, MultipleLineText);
  defaultFieldFactory.setComponent(CustomFieldTypes.Telephone, Telephone);
  defaultFieldFactory.setComponent(CustomFieldTypes.TelephoneWithDialCode, TelephoneWithDialCode);
  defaultFieldFactory.setComponent(CustomFieldTypes.RichText, RichText);
  defaultFieldFactory.setComponent(CustomFieldTypes.RadioButtonList, RadioButtonList);
  defaultFieldFactory.setComponent(CustomFieldTypes.UserDevicesSelector, UserDevicesSelector);
  defaultFieldFactory.setComponent(CustomFieldTypes.NumberInput, NumberInput);

  return defaultFieldFactory;
}

export default createCustomFieldFactory();
